import { OAuthTokensTable } from '@/components/iam/OAuthTokensTable';
import { RevokeAllOAuthTokensButton } from '@/components/iam/RevokeAllOAuthTokensButton';

export const UserOAuthTokensTab = ({ userId }: { userId: number }) => (
  <OAuthTokensTable
    filter={{ field: 'user_id', value: userId }}
    titleKey="iam.users.tabs.oauth_tokens"
    extra={<RevokeAllOAuthTokensButton userId={userId} />}
  />
);
